<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.58366 17.4993C13.9559 17.4993 17.5003 13.9549 17.5003 9.58268C17.5003 5.21043 13.9559 1.66602 9.58366 1.66602C5.2114 1.66602 1.66699 5.21043 1.66699 9.58268C1.66699 13.9549 5.2114 17.4993 9.58366 17.4993Z" stroke="#737278" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.3337 18.3327L16.667 16.666" stroke="#737278" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
